var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0"},_vm._l((_vm.events),function(event){return _c('EventRow',{key:event.id,attrs:{"event":event},on:{"delete-event":function($event){return _vm.deleteEvent(event.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }